import { styled } from "@mui/material";

export const Wrapper = styled("div")(({ theme }) => (props) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "start",
  width: "100%",
  margin: "0px 50px",
  [theme.breakpoints.down("md")]: {},
}));

export const RatingList = styled("div")(({ theme }) => (props) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  width: "100%",
  // margin: "10px auto",
  [theme.breakpoints.down("md")]: {},
}));

export const FormWrapper = styled("div")(({ theme }) => (props) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  width: "100%",
  marginTop: '20px',
  gap: "20px",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
  },
}));
